import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  content: {
    height: '100%',
  },
  wrapper: {
    overflow: 'auto',
  },
  paper: {
    width: 235,
    height: 228,
    boxSizing: 'border-box',
  },
  icon: {
    width: 76,
    height: 76,
    borderRadius: 50,
  },
}));
